<template>
    <div class="forgetWraper">
        <div class="form form-2"
             v-show="!nextStep">
            <div class="group group-1">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="19px"
                     height="22px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M9.493,11.001 C12.498,11.001 14.938,8.538 14.938,5.500 C14.938,2.462 12.498,-0.000 9.493,-0.000 C6.486,-0.000 4.048,2.462 4.048,5.500 C4.048,8.538 6.484,11.001 9.493,11.001 ZM16.994,14.433 C15.750,12.997 15.329,12.503 13.052,12.371 L5.942,12.371 C3.662,12.506 3.244,12.997 2.003,14.433 C0.681,15.914 -0.372,17.796 0.126,20.124 C0.681,21.650 2.174,22.000 3.591,22.000 L15.407,22.000 C16.823,22.000 18.319,21.647 18.874,20.124 C19.367,17.796 18.316,15.916 16.994,14.433 Z" />
                </svg>
                <input type="text"
                       class="userName"
                       v-model="formForget.passport"
                       placeholder="请输入手机号"
                       maxlength="11"
                       spellcheck="false"
                       @focus="fnInputFocus"
                       @blur="fnInputBlur('phone')" />
            </div>
            <div class="group group-2">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="19px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M18.952,4.877 C18.932,4.172 18.388,3.506 17.746,3.385 C17.746,3.385 15.255,2.962 13.857,2.428 C12.112,1.760 10.385,0.293 10.385,0.293 C9.846,-0.120 9.020,-0.094 8.520,0.353 C8.520,0.353 7.298,1.678 5.017,2.452 C2.909,3.362 1.225,3.455 1.225,3.455 C0.589,3.544 0.042,4.175 0.029,4.880 C0.029,4.880 -0.056,8.504 0.052,11.685 C0.093,17.375 6.361,23.000 9.529,23.000 C12.647,23.000 18.036,19.081 18.883,11.767 C19.093,7.425 18.952,4.877 18.952,4.877 ZM14.089,9.869 L8.699,15.731 C8.469,15.981 8.080,16.010 7.816,15.784 L5.001,13.381 C4.484,12.939 4.430,12.171 4.888,11.656 C5.342,11.146 6.122,11.078 6.650,11.522 L7.956,12.621 L12.446,8.075 C12.914,7.601 13.658,7.615 14.114,8.083 C14.108,8.076 14.106,8.066 14.099,8.058 L14.137,8.099 C14.130,8.092 14.121,8.090 14.114,8.083 C14.553,8.579 14.547,9.370 14.089,9.869 Z" />
                </svg>
                <input type="text"
                       class="verifyCode"
                       v-model="formForget.verifyCode"
                       placeholder="请输入验证码"
                       maxlength="6"
                       @focus="fnInputFocus"
                       @keyup.enter="fnDoForget" />
                <a href="javascript:;"
                   class="btnNml btnGetVerifyCode"
                   :class="{btnGray: btnDisable}"
                   @click="fnVerify"
                   v-text="btnVerifyCode"></a>
            </div>
            <div class="group group-3">
                <div class="errMsg"
                     v-text="formForget.errMsg"></div>
            </div>
            <div class="group group-4">
                <a href="javascript:;"
                   class="btnNml btnSubmit"
                   @click="fnDoFoget"
                   v-text="'下一步'"></a>
            </div>
            <div class="group group-5">
                <p>您还没有绑定手机号？</p>
                <p>
                    <a href="https://register.stnts.com/new/v2/findpwd/step1.do"
                       target="_blank"
                       class="colorfd9d2b">前往查看更多重置方式>></a>
                </p>
            </div>
            <div class="group group-6"
                 style="text-align: center">
                <a href="javascript:;"
                   @click="fnSwitchLoger('normal')"
                   class="colorfd9d2b">&lt;&lt; 返回登录</a>
            </div>
        </div>
        <div class="form form-3"
             v-show="nextStep">
            <div class="group group-10">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="17px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M14.455,23.000 L2.545,23.000 C1.142,22.997 0.006,21.728 -0.000,20.159 L-0.000,11.167 C0.006,9.597 1.142,8.327 2.545,8.320 L2.905,8.320 L2.905,6.261 C2.906,2.803 5.412,0.000 8.504,0.001 C11.594,0.001 14.100,2.804 14.100,6.261 L14.100,8.320 L14.455,8.320 C15.858,8.327 16.994,9.597 17.000,11.167 L17.000,20.159 C16.994,21.728 15.857,22.997 14.455,23.000 ZM7.443,16.133 L7.443,19.090 L9.540,19.090 L9.540,16.140 L9.557,16.133 C9.884,15.924 10.155,15.620 10.343,15.254 C10.926,14.115 10.574,12.663 9.557,12.010 C8.539,11.357 7.241,11.751 6.657,12.890 C6.073,14.028 6.425,15.481 7.443,16.133 ZM12.462,6.261 C12.462,3.815 10.689,1.833 8.502,1.833 C6.316,1.833 4.544,3.816 4.543,6.261 L4.543,8.320 L12.462,8.320 L12.462,6.261 Z" />
                </svg>
                <input type="password"
                       class="userPwd"
                       v-model="formReset.password"
                       placeholder="请输入密码"
                       @focus="fnInputFocus" />
            </div>
            <div class="group group-11">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="17px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M14.455,23.000 L2.545,23.000 C1.142,22.997 0.006,21.728 -0.000,20.159 L-0.000,11.167 C0.006,9.597 1.142,8.327 2.545,8.320 L2.905,8.320 L2.905,6.261 C2.906,2.803 5.412,0.000 8.504,0.001 C11.594,0.001 14.100,2.804 14.100,6.261 L14.100,8.320 L14.455,8.320 C15.858,8.327 16.994,9.597 17.000,11.167 L17.000,20.159 C16.994,21.728 15.857,22.997 14.455,23.000 ZM7.443,16.133 L7.443,19.090 L9.540,19.090 L9.540,16.140 L9.557,16.133 C9.884,15.924 10.155,15.620 10.343,15.254 C10.926,14.115 10.574,12.663 9.557,12.010 C8.539,11.357 7.241,11.751 6.657,12.890 C6.073,14.028 6.425,15.481 7.443,16.133 ZM12.462,6.261 C12.462,3.815 10.689,1.833 8.502,1.833 C6.316,1.833 4.544,3.816 4.543,6.261 L4.543,8.320 L12.462,8.320 L12.462,6.261 Z" />
                </svg>
                <input type="password"
                       class="userPwd"
                       v-model="formReset.repassword"
                       placeholder="请再次输入密码"
                       @focus="fnInputFocus"
                       @keyup.enter="fnDoSubmit" />
            </div>
            <div class="group errMsg"
                 v-text="formReset.errMsg"></div>
            <div class="group group-13">
                <a href="javascript:;"
                   class="btnNml btnSubmit"
                   @click="fnDoReset"
                   v-text="btnResetTxt"></a>
            </div>
            <div class="group group-14">
                <a href="javascript:;"
                   class="colorfd9d2b"
                   @click="fnSwitchLoger(6)">返回上一步&gt;&gt;</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'forget',
    data () {
        return {
            formForget: {
                passport: '',
                verifyCode: '',
                errMsg: ''
            },
            formReset: {
                passport: '',
                password: '',
                repassword: '',
                verifyCode: '',
                errMsg: ' '
            },
            captchaObj: null,
            btnSubmitTxt: '开始游戏',
            btnDisable: false,
            btnVerifyCode: '获取验证码',
            btnVerifyCodeNum: 60,
            btnVerifyCodeTimer: null,
            nextStep: false,
            btnResetTxt: '重置密码'
        }
    },
    mounted () {
        let t = this
        t.captchaObj && t.captchaObj.reset()
        t.fnGeeInit(function (geeData) {
            t.fnGetVerifyCodeForget(geeData)
        })
    },
    methods: {
        // 忘记密码
        fnDoFoget () {
            var t = this
            if (!t.formForget.passport) {
                t.formForget.errMsg = '手机号不能为空'
                return
            }

            if (!t.formForget.verifyCode) {
                t.formForget.errMsg = '验证码不能为空'
                return
            }
            t.nextStep = true
        },
        // 忘记密码发送短信前置验证
        fnGetVerifyCodeForget (geeData) {
            let t = this
            if (!t.formForget.passport) {
                t.formForget.errMsg = '手机号不能为空'
                return
            }
            if (t.btnDisable) return
            t.btnDisable = true
            geeData = geeData || {}
            geeData.phone = t.formForget.passport
            this.fnSendVerifyCode(geeData, 1)
        },
        // 获取重置密码验证码
        fnSendVerifyCode (geeData, type) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('forget', geeData, (res) => {
                if (res.status === 'error') {
                    t.btnDisable = false
                    if (type) {
                        t.formForget.errMsg = res.msg
                    } else {
                        t.formPhone.errMsg = res.msg
                    }
                    return
                }
                t.btnVerifyCodeTimer = setInterval(() => {
                    t.btnVerifyCodeNum--
                    if (t.btnVerifyCodeNum < 1) {
                        t.btnVerifyCodeNum = 0
                        t.btnVerifyCodeNum = 60
                        t.btnDisable = false
                        t.btnVerifyCode = '获取验证码'
                        clearInterval(t.btnVerifyCodeTimer)
                        return
                    }
                    t.btnVerifyCode = t.btnVerifyCodeNum + 's后重新获取'
                }, 1000)
            })
        },
        // 忘记密码获取验证码
        fnVerify () {
            let t = this
            if (!t.formForget.passport) {
                t.formForget.errMsg = '手机号不能为空'
                return
            }
            this.captchaObj.verify()
        },
        // 重置密码
        fnDoReset () {
            let t = this
            if (!t.formReset.password) {
                t.formReset.errMsg = this.$store.state.errMsg.reg[1]
                return
            }
            if (t.formReset.password.length < 6 || t.formReset.password.length > 16) {
                t.formReset.errMsg = this.$store.state.errMsg.reg[3]
                return
            }
            if (!t.formReset.repassword) {
                t.formReset.errMsg = this.$store.state.errMsg.reg[2]
                return
            }
            if (t.formReset.password !== t.formReset.repassword) {
                t.formReset.errMsg = this.$store.state.errMsg.reg[4]
                return
            }
            if (t.btnClickFast) return
            t.btnClickFast = true
            t.btnResetTxt = '重置中，请稍候'
            // eslint-disable-next-line
            ELSDK.SDKAPI(
                'forgetReset',
                {
                    phone: t.formForget.passport,
                    code: t.formForget.verifyCode,
                    password: t.formReset.password
                },
                (res) => {
                    if (res.status === 'error') {
                        t.errMsg = res.msg
                        return
                    }
                    this.$emit('fnBtnClick', 'normal')
                }
            )
        },
        // 极验初始化
        fnGeeInit (fn) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('geeInit', {}, (captchaObj) => {
                // debugger
                t.captchaObj = captchaObj
                t.captchaObj.onSuccess(function () {
                    var result = t.captchaObj.getValidate()
                    if (!result) {
                    } else {
                        var geeData = {
                            gee_client_type: 'web',
                            gee_challenge: result.geetest_challenge,
                            gee_validate: result.geetest_validate,
                            gee_seccode: result.geetest_seccode
                        }
                        fn && fn(geeData)
                    }
                })
            })
        },
        // 获取焦点
        fnInputFocus () {
            this.formForget.errMsg = ''
        },
        // 失去焦点
        fnInputBlur (key) { },
        fnSwitchLoger (type) {
            if (type == 6) {
                this.nextStep = false
            }
            this.$emit('fnBtnClick', type)
        }
    },
    destroyed () {
        clearInterval(this.btnVerifyCodeTimer)
    }
}
</script>

<style lang="less" scoped>
</style>
